import React, { forwardRef } from 'react';

export interface IElement {
  children?: any;
  className?: string;
  disabled?: boolean;
  id?: string;
  htmlTag?: string;
  maxLength?: number;
  onClick?: Function;
  onBlur?: Function;
  onChange?: Function;
  placeholder?: string;
  style?: {};
  value?: string;
}

const Element = forwardRef(({ htmlTag, children, ...props }: IElement, ref: React.Ref<Element> | null) => React.createElement(htmlTag || 'div', { ...props, ref }, children));

Element.displayName = 'Element';

Element.defaultProps = {
  htmlTag: 'div',
};

export default Element;
